import React, { useEffect, useState } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Typography,
  IconButton,
  Paper,
  FormControl,
  Checkbox,
  Tooltip,
  LinearProgress
} from '@material-ui/core';
import { TreeSelect } from 'antd';
import { Autocomplete } from '@material-ui/lab';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { CheckBoxOutlineBlank } from '@material-ui/icons';
import Button from 'components/Button/button';
import DefaultImage from 'images/defaultAndEmpties/defaultAndEmptyMediumImageRectangleNoBg.svg';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/close-icon-white.svg';
import CloseGrayIcon from 'images/icons/signals/closesAndCancels/closeGrayOutline.svg';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import Draggable from 'react-draggable';
import * as UserActions from 'store/actions/user';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Axios from 'axios';
import Environment from 'utils/environments';
import getOptions from 'services/getOptions';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ImageCropper from 'components/Register/ImageCropper';
import { ProductDialogContainer } from '../../styles';
import { setSubGroupsAndStores } from 'utils/setSubGroupsAndStores';
import CommonAlert from 'components/CommonAlert/CommonAlert';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggableLabelPrintingProductDialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const environment = Environment(process.env.REACT_APP_ENV);
const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function ProductDialog({ open, onClose, onSuccess, onlyView, userInfo }) {
  const { id: paramsID, productId } = useParams();
  const getId =
    userInfo?.companiesActive?.id === paramsID
      ? userInfo?.companiesActive
      : paramsID || null;

  const [userGroups, setUserGroups] = useState({
    groups: [
      {
        subGroups: [
          {
            stores: [{}]
          }
        ]
      }
    ]
  });
  const [restaurantGroups, setRestaurantGroups] = useState([
    userInfo.companies.groups[0]
  ]);
  const [restaurantSubGroups, setRestaurantSubGroups] = useState([]);
  const [restaurantStores, setRestaurantStores] = useState([]);
  const [consumptionUnitOptions, setConsumptionUnitOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [conservationOptions, setConservationOptions] = useState([]);
  const [product, setProduct] = useState();
  const [loadedProduct, setLoadedProduct] = useState(false);
  const [loadCategories, setLoadCategories] = useState(false);
  const [cropper, setCropper] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingSaving, setLoadingSaving] = useState(false);
  const [loadedConsumptionUnitOptions, setLoadedConsumptionUnitOptions] =
    useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const [imageData, setImageData] = useState({
    data: {
      images: null
    }
  });
  const [modalSettings, setModalSettings] = useState([
    {
      id: 1,
      name: 'imageCropper',
      open: false,
      fullScreen: false,
      maxWidth: 'sm'
    }
  ]);
  const [invalidFields, setInvalidFields] = useState({
    groups: false,
    subGroups: false,
    stores: false,
    description: false,
    unitPrimary: false,
    expirationType: false,
    expirationDuration: false
  });
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  const validityTypeOptions = [
    { id: 'DAY', description: 'Dias' },
    { id: 'HOUR', description: 'Horas' }
  ];

  async function fetchRestaurantsOfProduct(productId) {
    const response = await fetch(
      `${environment.catalog}/products/${productId}/groups`
    );
    const groups = await response.json();

    return groups;
  }

  const pluckIds = (arr) => arr.map((obj) => obj.id);

  const buildStores = (subGroup) => {
    const stores = subGroup.stores.filter((store) =>
      pluckIds(restaurantStores).includes(store.id)
    );

    return stores.map((store) => ({
      id: store.id,
      name: store.name
    }));
  };

  const buildSubGroups = (group) => {
    const subGroups = group.subGroups.filter((subGroup) =>
      pluckIds(restaurantSubGroups).includes(subGroup.id)
    );

    return subGroups.map((subGroup) => ({
      id: subGroup.id,
      name: subGroup.name,
      stores: buildStores(subGroup)
    }));
  };

  const getCropData = () => {
    setImageData({
      ...imageData,
      data: {
        images: {
          ...imageData?.data?.images,
          baseImage: cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.9),
          url: cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.9)
        }
      }
    });
  };

  const handleSelectImage = (_e, index) => {
    setHasChanged(true);

    if (index || index === 0) {
      document.querySelector(`#fileInput${index}`).click();
    } else {
      document.querySelector(`#fileInput`).click();
    }
  };

  const handleClearFileInput = () => {
    setHasChanged(true);

    document.querySelector(`#fileInput`).value = null;
  };

  const handleRemoveImage = () => {
    setImageData({
      data: {
        images: null
      }
    });
  };

  const onChangeImage = (e) => {
    if (!e?.target?.files?.length) return;

    setHasChanged(true);

    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    setHasChanged(true);
    const reader = new FileReader();

    reader.onload = () => {
      setImageData({
        data: {
          images: {
            url: reader.result,
            baseImage: reader.result,
            name: files?.length && files[0]?.name
          }
        }
      });

      setModalSettings(
        modalSettings.map((modal) =>
          modal.name === 'imageCropper' ? { ...modal, open: true } : modal
        )
      );
    };
    reader.readAsDataURL(files?.length && files[0]);
  };

  const getProduct = () => {
    if (productId && !loadedProduct && loadedConsumptionUnitOptions) {
      setLoading(true);

      Axios.get(
        `${environment.catalog}/printer/products/${productId}?restaurantId=${getId}`
      )
        .then((response) => {
          setLoadedProduct(true);

          const currentProduct = response?.data;

          const expirationTypeRaw =
            currentProduct?.expirationType ||
            (currentProduct?.quantityValidDays !== undefined ? 'DAY' : null);

          const validityType =
            validityTypeOptions.find(
              (opt) => opt.id === (expirationTypeRaw || '').toUpperCase()
            ) || null;

          const expirationDuration =
            currentProduct?.expirationDuration ??
            currentProduct?.quantityValidDays ??
            null;

          setProduct({
            id: currentProduct?.id || null,
            description: currentProduct?.description || null,
            restaurantId: currentProduct?.restaurantId || paramsID,
            category: currentProduct?.categories || null,
            conservationId: currentProduct?.conservationId || null,
            quantityValidDays: currentProduct?.quantityValidDays || null,
            unitPrimary: currentProduct?.consumptionUnitsPrimary || null,
            user: currentProduct?.user || userInfo.user,
            created_at: currentProduct?.created_at || null,
            updated_at: currentProduct?.updated_at || null,
            productsGroupId: currentProduct?.productsGroupId || null,
            validityType,
            expirationDuration
          });

          setImageData({
            data: {
              images: {
                ...currentProduct?.image,
                name: currentProduct?.image?.name,
                url: currentProduct?.image?.url
              }
            }
          });

          setLoading(false);
        })
        .catch((error) => {
          setMessage({
            description: `Produto não encontrado, por favor confirme se o id do restaurante e do produto estão corretos`,
            status: 'error',
            autoHideDuration: 5000
          });
          setLoading(false);
          console.log(error);
        });
    }
  };

  const hasInvalidFields = () => {
    const invalids = {
      description: !product?.description,
      unitPrimary: !product?.unitPrimary,
      groups: !(restaurantGroups?.length > 0),
      subGroups: !(restaurantSubGroups?.length > 0),
      stores: !(restaurantStores?.length > 0)
    };

    const typeId = product?.validityType?.id;
    invalids.expirationType = !typeId;
    invalids.expirationDuration =
      typeId === 'DAY'
        ? product?.expirationDuration === null ||
          product?.expirationDuration === undefined ||
          product?.expirationDuration === ''
        : typeId === 'HOUR'
        ? !(Number(product?.expirationDuration) > 0)
        : false;
    setInvalidFields(invalids);
    return Object.values(invalids).some(Boolean);
  };

  const onSubmitProduct = async () => {
    setLoadingSaving(true);

    if (hasInvalidFields()) {
      setLoadingSaving(false);
      return;
    }

    const isUpdate = Boolean(productId);
    const url = isUpdate
      ? `${environment.catalog}/printer/products/${productId}`
      : `${environment.catalog}/printer/products`;
    const method = isUpdate ? 'put' : 'post';

    const expirationType = product?.validityType?.id || null;
    const expirationDuration =
      expirationType === 'HOUR'
        ? Number(product?.expirationDuration || 0)
        : Number(product?.expirationDuration || 0);

    const payload = {
      groups: userGroups.groups.map((group) => group.hasOwnProperty('id'))[0]
        ? restaurantGroups.map((group) => ({
            id: group.id,
            name: group.name,
            subGroups: buildSubGroups(group)
          }))
        : null,
      restaurantId: paramsID,
      categoryId: product?.category?.id,
      conservationId: product.conservationId,
      categoryDescription: product?.category?.description,
      consumptionUnitsPrimaryId: product.unitPrimary?.id,
      user: product?.user || userInfo?.user,
      quantityValidDays: null,
      description: product.description,
      image: imageData?.data?.images?.url,
      expirationType,
      expirationDuration,
      ...(isUpdate && {
        imageId: imageData?.data?.images?.id,
        productsGroupId: product.productsGroupId
      })
    };

    try {
      const response = await Axios[method](url, payload);

      setMessage({
        description: isUpdate
          ? 'Produto atualizado com sucesso!'
          : 'Produto criado com sucesso!',
        status: 'success'
      });

      setTimeout(() => {
        onClose?.();
        onSuccess?.();
      }, 500);
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message || 'Erro ao salvar produto';

      console.error('Erro ao salvar produto:', error);

      setMessage({
        description: errorMsg,
        status: 'error'
      });
    } finally {
      setLoadingSaving(false);
    }
  };

  useEffect(() => {
    setUserGroups({ groups: userInfo.companies.groups });
  }, [userInfo]);

  useEffect(() => {
    (async () => {
      const groupActive =
        userInfo.companies.groups.length > 0
          ? userInfo.companies.groups.find((group) =>
              group.subGroups.some((subGroup) =>
                subGroup.stores.some(
                  (store) => store.id === userInfo.companiesActive.id
                )
              )
            )
          : {};
      const subGroupActive =
        userInfo.companies.groups.length > 0
          ? groupActive.subGroups.find((subGroup) =>
              subGroup.stores.some(
                (store) => store.id === userInfo.companiesActive.id
              )
            )
          : {};

      if (productId) {
        const origins = await fetchRestaurantsOfProduct(productId);

        if (origins && origins.length > 0) {
          const { selectedSubGroups, selectedStores } = setSubGroupsAndStores({
            subGroups: groupActive.subGroups,
            originIds: origins
          });

          setRestaurantSubGroups(selectedSubGroups);
          setRestaurantStores(selectedStores);
        } else {
          setRestaurantSubGroups([subGroupActive]);
          setRestaurantStores(subGroupActive.stores);
        }
      } else {
        setRestaurantSubGroups([subGroupActive]);
        setRestaurantStores(subGroupActive.stores);
      }
    })();
  }, [userInfo.companiesActive]);

  useEffect(() => {
    if (!conservationOptions.length) {
      getOptions(
        `${environment.catalog}/conservation`,
        'conservation',
        conservationOptions,
        setConservationOptions,
        getId
      );
    }

    if (!categoryOptions.length) {
      getOptions(
        `${environment.catalog}/categories`,
        'categories',
        categoryOptions,
        setCategoryOptions,
        getId
      );
    }

    if (!consumptionUnitOptions.length) {
      Axios.get(`${environment.catalog}/consumptionUnits?page=1&size=1500`)
        .then((response) => {
          const units = response.data.content;
          setConsumptionUnitOptions(units);
          setLoadedConsumptionUnitOptions(true);
        })
        .catch((error) => {});
    }
  }, [getId, loadCategories]);

  useEffect(() => {
    if (productId) {
      getProduct();
    }
  }, [getId, productId, loadedConsumptionUnitOptions, userInfo.user]);

  return (
    <ProductDialogContainer
      className="defaultModal"
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle
        className="modalHeader lightBlue bold textAlignCenter cursorMove"
        id="draggableLabelPrintingProductDialog"
        fullWidth
      >
        <Typography>
          {productId ? 'EDIÇÃO DE PRODUTO' : 'CADASTRO DE PRODUTO'}
        </Typography>

        <IconButton
          onClick={onClose}
          style={{ outline: '0', background: 'none', align: 'right' }}
        >
          <img
            style={{ width: '16px' }}
            src={CloseIconNavy}
            alt="CloseIconNavy"
          />
        </IconButton>
      </DialogTitle>

      {loading ? <LinearProgress /> : null}

      <DialogContent className="cardDefault">
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Autocomplete
              multiple
              className={`autocompleteSmall backgroundInput ${
                invalidFields?.groups && 'labelError'
              }`}
              limitTags={1}
              disabled={onlyView}
              options={userGroups.groups}
              disableCloseOnSelect
              size="small"
              value={restaurantGroups}
              getOptionLabel={(option) => option.name}
              onChange={(_, value) => {
                if (value) {
                  setHasChanged(true);
                  setRestaurantGroups(value);
                  setRestaurantSubGroups(
                    value
                      .reduce((acc, group) => [...acc, group.subGroups], [])
                      .flat()
                  );
                  setRestaurantStores(
                    value
                      .reduce((acc, group) => [...acc, group.subGroups], [])
                      .flat()
                      .reduce((acc, subGroup) => [...acc, subGroup.stores], [])
                      .flat()
                  );
                }
              }}
              renderOption={(option, { selected }) => (
                <>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.name}
                </>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Grupos"
                  placeholder="Grupos"
                  InputLabelProps={{
                    style: { fontFamily: 'Lato', fontSize: '12px' }
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={4}>
            <Autocomplete
              multiple
              className={`autocompleteSmall backgroundInput ${
                invalidFields?.subGroups && 'labelError'
              }`}
              limitTags={1}
              disabled={onlyView}
              options={restaurantGroups
                .reduce((acc, group) => [...acc, group.subGroups], [])
                .flat()}
              value={restaurantSubGroups}
              disableCloseOnSelect
              size="small"
              getOptionLabel={(option) => option.name}
              onChange={(_, value) => {
                if (value) {
                  setHasChanged(true);
                  setRestaurantSubGroups(value);
                  setRestaurantStores(
                    value
                      .reduce((acc, subGroup) => [...acc, subGroup.stores], [])
                      .flat()
                  );
                }
              }}
              renderOption={(option, { selected }) => (
                <>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.name}
                </>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Subgrupos"
                  placeholder="Subgrupos"
                  InputLabelProps={{
                    style: { fontFamily: 'Lato', fontSize: '12px' }
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={4}>
            <Autocomplete
              multiple
              className={`autocompleteSmall backgroundInput ${
                invalidFields?.stores && 'labelError'
              }`}
              limitTags={1}
              disabled={onlyView}
              options={restaurantSubGroups
                .reduce((acc, subGroup) => [...acc, subGroup.stores], [])
                .flat()}
              value={restaurantStores}
              disableCloseOnSelect
              size="small"
              getOptionLabel={(option) => option.name}
              onChange={(_, value) => {
                if (value) {
                  setHasChanged(true);
                  setRestaurantStores(value);
                }
              }}
              renderOption={(option, { selected }) => (
                <>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.name}
                </>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Restaurantes"
                  placeholder="Restaurantes"
                  InputLabelProps={{
                    style: { fontFamily: 'Lato', fontSize: '12px' }
                  }}
                />
              )}
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sm={12}
            className={invalidFields?.description && 'labelError'}
          >
            <TextField
              onChange={(e) => {
                const { value } = e.target;
                setHasChanged(true);

                setProduct((prevState) => ({
                  ...prevState,
                  description: value
                }));
              }}
              id="productFormInputDescription"
              type="text"
              name="description"
              variant="outlined"
              label="Descrição"
              placeholder="Digite aqui..."
              fullWidth
              size="small"
              className="textFieldSmall backgroundInput"
              value={product?.description || ''}
              InputLabelProps={{
                shrink: true
              }}
              disabled={onlyView}
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={2}
            sm={6}
            className={invalidFields?.unitPrimary && 'labelError'}
          >
            <Autocomplete
              id="asynchronous-demo"
              getOptionSelected={(option, value) => option.id === value.id}
              getOptionLabel={(option) =>
                option?.abbreviation || option?.description || ''
              }
              options={consumptionUnitOptions}
              value={
                product?.unitPrimary
                  ? consumptionUnitOptions.find(
                      (el) => el?.id === product.unitPrimary.id
                    )
                  : null
              }
              size="small"
              className="autocompleteSmall backgroundInput"
              onChange={(_, value) => {
                setHasChanged(true);
                setProduct((prevState) => ({
                  ...prevState,
                  unitPrimary: value
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  type="text"
                  label="Un Primária"
                  variant="outlined"
                  placeholder="Selecione..."
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              )}
              renderOption={(params) => (
                <Typography style={{ fontSize: '12px', fontFamily: 'Lato' }}>
                  {params.abbreviation}
                </Typography>
              )}
              disabled={onlyView}
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={2}
            sm={6}
            className={`${invalidFields?.expirationDuration && 'labelError'}`}
          >
            <FormControl fullWidth>
              <CurrencyTextField
                fullWidth
                variant="outlined"
                size="small"
                currencySymbol=""
                minimumValue="0"
                outputFormat="string"
                decimalCharacter=","
                digitGroupSeparator="."
                decimalPlaces={0}
                decimalPlacesShownOnFocus={0}
                type="text"
                name="expirationDuration"
                className="textFieldSmall rightValue backgroundInput"
                label="Validade"
                placeholder="Digite aqui..."
                onBlur={(e) => {
                  const raw = (e.target.value || '')
                    .toString()
                    .replace(/\./g, '')
                    .replace(/,/g, '.');

                  const hasInput = raw.trim() !== '';
                  const formattedValue = hasInput ? Number(raw) : null;

                  setHasChanged(true);
                  setProduct((prevState) => ({
                    ...prevState,
                    expirationDuration: formattedValue
                  }));
                }}
                value={
                  product?.expirationDuration !== undefined &&
                  product?.expirationDuration !== null
                    ? String(product?.expirationDuration)
                    : ''
                }
                disabled={onlyView}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={2} sm={6} className="mb0">
            <Autocomplete
              id="validity-type"
              options={validityTypeOptions}
              getOptionSelected={(option, value) => option.id === value.id}
              getOptionLabel={(option) => option?.description || ''}
              value={product?.validityType || null}
              size="small"
              className={`autocompleteSmall backgroundInput ${
                invalidFields?.expirationType && 'labelError'
              }`}
              disabled={onlyView}
              onChange={(_, value) => {
                setHasChanged(true);
                setProduct((prev) => {
                  const prevState = prev ?? {};
                  return {
                    ...prevState,
                    validityType: value || null,
                    expirationDuration: prevState.expirationDuration ?? null
                  };
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  type="text"
                  label="Tipo"
                  variant="outlined"
                  placeholder="Selecione..."
                  InputLabelProps={{ shrink: true }}
                />
              )}
              renderOption={(option) => (
                <Typography style={{ fontSize: '12px', fontFamily: 'Lato' }}>
                  {option.description}
                </Typography>
              )}
            />
          </Grid>

          <Grid item xs={5} md={5} sm={5} className="mb0">
            <FormControl className="selectSmallBox" fullWidth>
              <label className="fontSizeDefault pAbsolute">Categorias</label>

              <TreeSelect
                id="productFormCategorieInput"
                suffixIcon={
                  <svg
                    className="MuiSvgIcon-root pAbsolute"
                    style={{ right: 0, bottom: '-7px' }}
                    focusable="false"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M7 10l5 5 5-5z" />
                  </svg>
                }
                style={{ width: '100%' }}
                className="backgroundWhiteInput"
                allowClear
                value={product?.category?.description || undefined}
                onDropdownVisibleChange={(event) => setLoadCategories(event)}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                treeData={categoryOptions}
                placeholder="Selecione..."
                showSearch
                filterTreeNode={(search, item) =>
                  item?.title
                    ?.toLowerCase()
                    ?.normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    ?.includes(
                      search
                        ?.toLowerCase()
                        ?.normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                    )
                }
                treeDefaultExpandAll
                onChange={(element) => {
                  if (!element) {
                    setProduct((prevState) => ({
                      ...prevState,
                      category: null
                    }));
                  }
                }}
                onSelect={(element, value) => {
                  if (element) {
                    setHasChanged(true);
                    setProduct((prevState) => ({
                      ...prevState,
                      category: value
                    }));
                  }
                }}
                dropdownMatchSelectWidth={true}
                disabled={onlyView}
              />

              <Tooltip
                title="Preencha este campo."
                placement="bottom-start"
                disableFocusListener
                disableHoverListener
                disableTouchListener
                arrow
              >
                <span width="1px" />
              </Tooltip>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={4}
            md={4}
            sm={4}
            className={invalidFields?.conservationId && 'labelError'}
          >
            <Autocomplete
              id="asynchronous-demo"
              getOptionSelected={(option, value) => option.id === value.id}
              getOptionLabel={(option) => option?.description || ''}
              options={conservationOptions}
              value={
                product?.conservationId
                  ? conservationOptions.find(
                      (el) => el?.id === product?.conservationId
                    )
                  : null
              }
              size="small"
              className="autocompleteSmall backgroundInput"
              onChange={(_, value) => {
                setHasChanged(true);
                setProduct((prevState) => ({
                  ...prevState,
                  conservationId: value?.id
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  type="text"
                  label="Estado de Conservação"
                  variant="outlined"
                  placeholder="Selecione..."
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              )}
              renderOption={(params) => (
                <Typography style={{ fontSize: '12px', fontFamily: 'Lato' }}>
                  {params.description}
                </Typography>
              )}
              disabled={onlyView}
            />
          </Grid>

          <Grid item xs={12} md={3} sm={6} className="mb0">
            <label className="fontSizeDefault pAbsolute">Imagem</label>

            <div className="productImageContainer">
              <div className="croppedImageBox">
                <Tooltip
                  arrow
                  placement="right"
                  disableHoverListener={!imageData?.data?.images?.url}
                  enterTouchDelay={0}
                  title={
                    <div
                      className={`cropDataSmallBox skuImgPreview mr0 ${
                        imageData?.data?.images?.url && 'bgWhite'
                      } largeSize`}
                    >
                      <img src={imageData?.data?.images?.url} alt="Card" />
                    </div>
                  }
                >
                  <div
                    className={`croppedImage ${
                      imageData?.data?.images?.url && 'bgWhite'
                    }`}
                  >
                    <img
                      src={imageData?.data?.images?.url || DefaultImage}
                      alt={`${
                        imageData?.data?.images?.url
                          ? 'Card Image'
                          : 'No Menu Image'
                      }`}
                    />
                  </div>
                </Tooltip>
              </div>

              <div className="dFlex flexColumn alignCenter ml10">
                <div className="dFlex justifyBetween alignCenter w100 h100">
                  <div className="dFlex alignCenter">
                    {imageData?.data?.images?.url && (
                      <img
                        style={{
                          margin: '0px 10px 0px 0px',
                          width: '12px'
                        }}
                        title="Remover imagem"
                        className={`${
                          onlyView ? 'cursorAuto' : 'cursorPointer'
                        }`}
                        src={CloseGrayIcon}
                        alt="CloseGrayIcon"
                        onClick={() => {
                          if (onlyView) return;

                          setHasChanged(true);
                          handleRemoveImage();
                          handleClearFileInput();
                        }}
                      />
                    )}
                  </div>

                  {imageData?.data?.images?.url ? (
                    <Button
                      className={`defaultButton ${
                        onlyView ? 'disabledButton' : 'backButton'
                      } sizeButtonMenu`}
                      design="outlined"
                      label="ESCOLHER OUTRA IMAGEM"
                      onClick={(e) => {
                        if (onlyView) return;

                        handleSelectImage(e, 'receiptMainImage');
                      }}
                      style={{ outline: 0 }}
                    />
                  ) : (
                    <Button
                      className={`defaultButton ${
                        onlyView ? 'disabledButton' : 'submitButton'
                      } sizeButtonMenu`}
                      design="outlined"
                      label="SELECIONAR IMAGEM"
                      onClick={(e) => {
                        if (onlyView) return;

                        handleSelectImage(e, 'receiptMainImage');
                      }}
                      style={{ outline: 0 }}
                    />
                  )}
                </div>

                <input
                  id={`fileInput${'receiptMainImage'}`}
                  type="file"
                  onChange={(e) => onChangeImage(e)}
                  className="dNone"
                />

                <input
                  id="fileInput"
                  type="file"
                  onChange={onChangeImage}
                  className="dNone"
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions className="dialogActions">
        <Button
          id="productFormSaveButton"
          className="defaultButton backButton"
          design="contained"
          label="VOLTAR"
          onClick={() => onClose()}
        />

        <Button
          id="productFormSaveButton"
          className={`defaultButton submitButton ${
            (!hasChanged || onlyView) && 'disabledButton'
          }`}
          design="contained"
          disabled={loadingSaving || !hasChanged || onlyView}
          label={loadingSaving ? 'SALVANDO...' : 'SALVAR'}
          onClick={() => onSubmitProduct()}
        />
      </DialogActions>

      {modalSettings.find((modal) => modal.name === 'imageCropper')?.open && (
        <ImageCropper
          modalSettings={modalSettings}
          setModalSettings={setModalSettings}
          getCropData={getCropData}
          obj={imageData}
          setObj={setImageData}
          setCropper={setCropper}
          handleSelectImage={handleSelectImage}
          handleClearFileInput={handleClearFileInput}
        />
      )}

      <CommonAlert
        open={message?.description}
        onClose={() => setMessage({ description: '', status: '' })}
        severity={message?.status}
        indexMessage={message?.description}
        messagePersonal={message?.description}
      />
    </ProductDialogContainer>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProductDialog);
